module.exports = __webpack_public_path__ + "static/media/img-3.2eed3f13.jpg";